import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5709c972"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "native-input" }
const _hoisted_2 = ["type", "value", "placeholder", "pattern"]
const _hoisted_3 = {
  key: 0,
  class: "fx-input-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(['fx-input', _ctx.focus && 'focus', !_ctx.isValid && 'no-valid'])
    }, [
      _renderSlot(_ctx.$slots, "prepend", {}, undefined, true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("input", {
          type: _ctx.type,
          value: _ctx.modelValue,
          style: _normalizeStyle({
          textAlign: _ctx.align,
          ..._ctx.style
        }),
          placeholder: _ctx.placeholder,
          pattern: _ctx.pattern,
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.inputHandler && _ctx.inputHandler(...args))),
          onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.focusHandler && _ctx.focusHandler(...args))),
          onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.blurHandler && _ctx.blurHandler(...args)))
        }, null, 44, _hoisted_2)
      ]),
      _renderSlot(_ctx.$slots, "append", {}, undefined, true)
    ], 2),
    (!_ctx.isValid)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.msg), 1))
      : _createCommentVNode("", true)
  ], 64))
}